/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button, useMediaQuery } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";
import { Logger } from "cms/utils/log/logger";

const Feedback = () => {
    
    // const anchorRef = useRef(null)
    // const [open, setOpen] = useState(false)
    // const theme = useTheme()
    const matchesXl = useMediaQuery((theme) => theme.breakpoints.down("lg"));
    
    const onFeedbackClick = async () => {
        Logger.info("Clicked onFeedbackClick in HeaderContent");
        location.href="mailto:info@simplicitycms.ca?subject=Feedback on Simplicity";
    };
    
    return (
        <>
            <Button
                color='neutral'
                startIcon={<SVGIcons.common.Feedback />}
                className="text-button-style"
                onClick={(event) => onFeedbackClick(event)}
            >
                {!matchesXl ? "Give feedback" : "Feedback"}
            </Button>
        </>
    );
};

export { Feedback };
